import { createHttpClient } from "./http";

export class VendaRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 300000 });
	}

	async save(data) {
		try {
			const result = await this.axios.post("venda", data, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
					"Content-Type": "application/json",
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao salvar venda.");
		}
	}

	async getAll(unidadeDistribuidoraId, search) {
		try {
			const params = {
				unidadeDistribuidoraId,
			};

			if (search) {
				params.search = search;
			}

			const result = await this.axios.get("venda", {
				params,
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao listar vendas.");
		}
	}

	async getById(id) {
		try {
			const result = await this.axios.get(`venda/${id}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao buscar venda.");
		}
	}

	async delete(id) {
		try {
			const result = await this.axios.delete(`venda/${id}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao excluir venda.");
		}
	}

	async getProdutosDisponiveis(unidadeDistribuidoraId, produtoFinalId) {
		try {
			const params = {
				unidadeDistribuidoraId,
			};

			if (produtoFinalId) {
				params.produtoFinalId = produtoFinalId;
			}

			const result = await this.axios.get("venda/produtos-disponiveis", {
				params,
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao buscar produtos disponíveis.");
		}
	}
}
